<template>
  <svg :aria-label="ariaLabel" :class="iconSizeClass" :data-qa="dataQA" :aria-hidden="ariaHidden" role="img" data-name="Film" class="d-icon d-icon--film" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg"><g :clip-path="`url(#${uniqueID}a)`"><path fill-rule="evenodd" clip-rule="evenodd" d="M2.09.5A1.59 1.59 0 0 0 .5 2.09v7.82c0 .878.712 1.59 1.59 1.59h7.82a1.59 1.59 0 0 0 1.59-1.59V2.09A1.59 1.59 0 0 0 9.91.5H2.09ZM4 5.5v-4h4v4H4Zm6.5 0H9V4h1.5v1.5Zm0-3.41a.59.59 0 0 0-.59-.59H9V3h1.5v-.91Zm0 5.91H9V6.5h1.5V8Zm-.59 2.5a.59.59 0 0 0 .59-.59V9H9v1.5h.91ZM1.5 2.09a.59.59 0 0 1 .59-.59H3V3H1.5v-.91ZM3 4H1.5v1.5H3V4ZM1.5 6.5H3V8H1.5V6.5Zm0 3.41c0 .326.264.59.59.59H3V9H1.5v.91ZM8 6.5v4H4v-4h4Z" fill="currentColor"/></g><defs><clipPath :id="`${uniqueID}a`"><path fill="#fff" d="M0 0h12v12H0z"/></clipPath></defs></svg>
</template>

<script>
import { getUniqueString } from '@/src/utils';
import { ICON_SIZE_MODIFIERS } from '@/src/constants';

export default {
  name: 'DtIconFilm',

  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: [String, Number],
      default: 500,
      validator: (s) => Object.keys(ICON_SIZE_MODIFIERS).includes(String(s)),
    },

    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: undefined,
    },
  },

  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ['loaded'],

  computed: {
    iconSizeClass () {
      return ICON_SIZE_MODIFIERS[this.size];
    },

    ariaHidden () {
      return !this.ariaLabel ? 'true' : 'false';
    },

    dataQA () {
      return this.$attrs['data-qa'] ?? 'dt-icon';
    },
  },

  created () {
    this.$emit('loaded');
    this.uniqueID = getUniqueString();
  },
};
</script>
